export default __webpack_public_path__ + "static/Calibre-SemiboldItalic-09946cbf0c10dc4d1447ca8442058731.ttf";